import { createFetchAction, createPostAction, createFormPostAction } from '../utils/reducer-utils';
import cloneDeep from 'lodash/cloneDeep';
import { fetch, addTask } from 'domain-task';
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import { addOrUpdate } from '../utils/utils';

const initialState = {
	isLoading: false,
	saveResult: {
		success: null,
		message: null,
		fields: [] 
	},
	outgoingCorrespondence: null, 
	outgoingCorrespondences: null
};

const emptyOutgoingCorrespondence = {
	_isNew: true,
	'outgoingCorrespondenceId': 0,
	'contractId': 0,
	'rfiNumber': '',
	'receivedDate': null,
	'docRefNo': '',
	'docTitle': '',
	'to': '',
	'from': null,
	'deliveryMethod': '',
	'sentDate': null,
	'timeBarred': false,
	'notificationUser': null,
	'actionRequired': false,
	'actionDueDate': null,
	'status': 'Open',
	'actionedBy': null,
	'actionDate': null,
	'comments': '',
	'dateAdded': new Date(),
	'files': [],
	tags: []
};

const CLEAR_OUTGOING_CORRESPONDENCES = 'CLEAR_OUTGOING_CORRESPONDENCES';
const CLEAR_OUTGOING_CORRESPONDENCE = 'CLEAR_OUTGOING_CORRESPONDENCE';
const REQUEST_OUTGOING_CORRESPONDENCE = 'REQUEST_OUTGOING_CORRESPONDENCE';
const RECEIVE_OUTGOING_CORRESPONDENCE = 'RECEIVE_OUTGOING_CORRESPONDENCE';
const REQUEST_OUTGOING_CORRESPONDENCES = 'REQUEST_OUTGOING_CORRESPONDENCES';
const RECEIVE_OUTGOING_CORRESPONDENCES = 'RECEIVE_OUTGOING_CORRESPONDENCES';
const CREATE_NEW_OUTGOING_CORRESPONDENCE = 'CREATE_NEW_OUTGOING_CORRESPONDENCE';
const SAVE_OUTGOING_CORRESPONDENCE = 'SAVE_OUTGOING_CORRESPONDENCE';
const RECEIVE_SAVE_OUTGOING_CORRESPONDENCE_RESPONSE = 'RECEIVE_SAVE_OUTGOING_CORRESPONDENCE_RESPONSE';
const DELETE_OUTGOING_CORRESPONDENCE = 'DELETE_OUTGOING_CORRESPONDENCE';
const RECEIVE_DELETE_OUTGOING_CORRESPONDENCE_RESPONSE = 'RECEIVE_DELETE_OUTGOING_CORRESPONDENCE_RESPONSE';
const SHOW_OUTGOING_CORRESPONDENCE_ERRORS = 'SHOW_OUTGOING_CORRESPONDENCE_ERRORS';
const GENERATE_OUTGOING_CORRESPONDENCE_NUMBER = 'GENERATE_OUTGOING_CORRESPONDENCE_NUMBER';
const RECEIVE_OUTGOING_CORRESPONDENCE_NUMBER = 'RECEIVE_OUTGOING_CORRESPONDENCE_NUMBER';
const UPDATE_OUTGOING_CORRESPONDENCE_NUMBER = 'UPDATE_OUTGOING_CORRESPONDENCE_NUMBER';
const UPDATE_OUTGOING_CORRESPONDENCE_SAVE_PROGRESS = 'UPDATE_OUTGOING_CORRESPONDENCE_SAVE_PROGRESS';

export const clearOutgoingCorrespondences = () => ({ type: CLEAR_OUTGOING_CORRESPONDENCES });
export const clearOutgoingCorrespondence = () => ({ type: CLEAR_OUTGOING_CORRESPONDENCE });
export const receiveOutgoingCorrespondences = (data) => ({ type: RECEIVE_OUTGOING_CORRESPONDENCES, payload: { data } });
export const receiveOutgoingCorrespondence = (data) => ({ type: RECEIVE_OUTGOING_CORRESPONDENCE, payload: { data } });
export const receiveSaveOutgoingCorrespondenceResponse = (data) => ({ type: RECEIVE_SAVE_OUTGOING_CORRESPONDENCE_RESPONSE, data });
export const receiveDeleteOutgoingCorrespondenceResponse = (data) => ({ type: RECEIVE_DELETE_OUTGOING_CORRESPONDENCE_RESPONSE, data });
export const receiveOutgoingCorrespondenceNumber = (data) => ({ type: RECEIVE_OUTGOING_CORRESPONDENCE_NUMBER, data });
export const updateSaveProgress = (progress) => ({ type: UPDATE_OUTGOING_CORRESPONDENCE_SAVE_PROGRESS, progress });

export const createNewOutgoingCorrespondence = (contractId) =>
	(dispatch) => {	
		const newCorrespondence = {
			...cloneDeep(emptyOutgoingCorrespondence)
		};
		dispatch({ type: CREATE_NEW_OUTGOING_CORRESPONDENCE, newCorrespondence: newCorrespondence });

		const fetchTask =  fetch(`/api/correspondence/get-outgoing-correspondence-number?contractId=${contractId}`, { 
				credentials: 'same-origin',
				headers: {
					'cache-control': 'no-store',
					'pragma': 'no-cache'
				}
			})
			.then(response => {
				if (response.status >= 200 && response.status < 300) return response.text();

				const error = new Error(response.statusText);
				error.response = response;
				throw error;
			})
			.then((data) => {
				dispatch({ type: UPDATE_OUTGOING_CORRESPONDENCE_NUMBER, number: data });
			}).catch((error) => {
				console.log('request failed', error);
			});
					
		addTask(fetchTask);
	};

export const requestOutgoingCorrespondences = () => (
	createFetchAction({
		objectName: 'Outgoing Correspondence',
		passContext: true,
		url: '/api/outgoing-correspondence',
		startAction: REQUEST_OUTGOING_CORRESPONDENCES,
		success: (data) =>
			receiveOutgoingCorrespondences(map(data, (c) => ({
				...c,
				receivedDate: c.receivedDate ? new Date(c.receivedDate) : null,
				sentDate: c.sentDate ? new Date(c.sentDate) : null,
				actionDueDate: c.actionDueDate ? new Date(c.actionDueDate) : null,
				actionDate: c.actionDate ? new Date(c.actionDate) : null
			})))
	})
);

export const requestOutgoingCorrespondence = (correspondenceId) => (
	createFetchAction({
		objectName: 'Outgoing Correspondence',
		passContext: true,
		url: `/api/outgoing-correspondence/${correspondenceId}`,
		startAction: REQUEST_OUTGOING_CORRESPONDENCE,
		success: (data) =>
			receiveOutgoingCorrespondence({
				...data,
				receivedDate: data.receivedDate ? new Date(data.receivedDate) : null,
				sentDate: data.sentDate ? new Date(data.sentDate) : null,
				actionDueDate: data.actionDueDate ? new Date(data.actionDueDate) : null,
				actionDate: data.actionDate ? new Date(data.actionDate) : null
			})
	})
);

export const saveOutgoingCorrespondence = (correspondence, newFiles, onSuccess) => {
	const errors = [];
	if (!correspondence.rfiNumber) {
		errors.push({
			fieldName: 'RfiNumber',
			valid: false,
			message: 'Outgoing Ref Number is required'
		});
	}
	if (!correspondence.docTitle) {
		errors.push({
			fieldName: 'DocTitle',
			valid: false,
			message: 'Document Title is required'
		});
	}
	if (correspondence.timeBarred && !correspondence.notificationUser) {
		errors.push({
			fieldName: 'NotificationUser',
			valid: false,
			message: 'You must set a user to notify when the correspondence is Time Barred'
		});
	}
	if (errors.length > 0) return { type: SHOW_OUTGOING_CORRESPONDENCE_ERRORS, data: errors };

	const formData = new FormData();
	formData.append('Correspondence', encodeURIComponent(JSON.stringify(correspondence)));
	forEach(newFiles, (f) => formData.append('NewFiles', f.file, f.fileName || f.file.name));

	return createFormPostAction({
		passContext: true,
		url: '/api/outgoing-correspondence',
		formData,
		startAction: SAVE_OUTGOING_CORRESPONDENCE,
		onProgress: (progress) => updateSaveProgress(progress),
		success: (data, dispatch) => {
			dispatch(receiveSaveOutgoingCorrespondenceResponse({
				...data,
				object: data.object ? {
					...data.object,
					receivedDate: data.object.receivedDate ? new Date(data.object.receivedDate) : null,
					sentDate: data.object.sentDate ? new Date(data.object.sentDate) : null,
					actionDueDate: data.object.actionDueDate ? new Date(data.object.actionDueDate) : null,
					actionDate: data.object.actionDate ? new Date(data.object.actionDate) : null
				} : data.object
			}));
			if (data.success && onSuccess) onSuccess.call(this, data);
		}
	});
};

export const deleteOutgoingCorrespondence = (correspondence, onSuccess) => (
	createPostAction({
		passContext: true,
		url: `/api/outgoing-correspondence/${correspondence.outgoingCorrespondenceId}/delete`,
		data: correspondence,
		startAction: DELETE_OUTGOING_CORRESPONDENCE,
		success: (data, dispatch) => {
			dispatch(receiveDeleteOutgoingCorrespondenceResponse(data));
			if (data.success && onSuccess) onSuccess.call(this, data);
		}
	})
);

export const generateOutgoingCorrespondenceNumber = () => (
	createPostAction({
		passContext: true,
		url: '/api/correspondence/get-outgoing-correspondence-number',
		startAction: GENERATE_OUTGOING_CORRESPONDENCE_NUMBER,
		success: (data) => receiveOutgoingCorrespondenceNumber(data)
	})
);


export default (state = initialState, action) => {
	switch (action.type) {
		case CLEAR_OUTGOING_CORRESPONDENCES:
			return {
				...state,
				outgoingCorrespondences: null
			};
		case CLEAR_OUTGOING_CORRESPONDENCE:
			return {
				...state,
				outgoingCorrespondence: null
			};
		case REQUEST_OUTGOING_CORRESPONDENCES:
			return {
				...state,
				isLoading: true,
				saveResult: {
					success: null,
					message: null,
					fields: [] 
				},
				outgoingCorrespondences: []
			};
		case RECEIVE_OUTGOING_CORRESPONDENCES:
			return {
				...state,
				isLoading: false,
				outgoingCorrespondences: action.payload.data
			};
		case REQUEST_OUTGOING_CORRESPONDENCE:
			return {
				...state,
				isLoading: true,
				saveResult: {
					success: null,
					message: null,
					fields: [] 
				},
				outgoingCorrespondence: cloneDeep(emptyOutgoingCorrespondence)
			};
		case RECEIVE_OUTGOING_CORRESPONDENCE:
			return {
				...state,
				isLoading: false,
				outgoingCorrespondence: action.payload.data
			};
		case DELETE_OUTGOING_CORRESPONDENCE:
			return { 
				...state
			};
		case RECEIVE_DELETE_OUTGOING_CORRESPONDENCE_RESPONSE:
			return {
				...state,
				outgoingCorrespondences: state.outgoingCorrespondences ? state.outgoingCorrespondences.filter(c => c.outgoingCorrespondenceId !== action.data.objectId) : state.outgoingCorrespondences
			};
		case CREATE_NEW_OUTGOING_CORRESPONDENCE:
			return {
				...state,
				outgoingCorrespondence: cloneDeep(emptyOutgoingCorrespondence)
			};	
		case SAVE_OUTGOING_CORRESPONDENCE:
			return {
				...state,
				isLoading: true,
				saveResult: {
					success: null,
					message: null,
					fields: [] 
				},
				message: null
			};
		case RECEIVE_SAVE_OUTGOING_CORRESPONDENCE_RESPONSE:
			if (!action.data.success) {
				return {
					...state,
					isLoading: false,
					saveResult: {
						success: action.data.success,
						message: action.data.message,
						fields: action.data.fields
					} 
				};
			}
			
			return {
				...state,
				outgoingCorrespondences: addOrUpdate(state.outgoingCorrespondences, action.data.object, { outgoingCorrespondenceId: action.data.object.outgoingCorrespondenceId }), 
				outgoingCorrespondence: action.data.object,				
				isLoading: false,
				saveResult: {
					success: action.data.success,
					message: action.data.message,
					fields: action.data.fields
				},
			};
		case SHOW_OUTGOING_CORRESPONDENCE_ERRORS:
			return {
				...state,
				isLoading: false,
				saveResult: {
					success: false,
					message: 'Please correct the errors',
					fields: action.data
				},
			};
		case GENERATE_OUTGOING_CORRESPONDENCE_NUMBER:
			return {
				...state,
				isLoading: true
			};
		case RECEIVE_OUTGOING_CORRESPONDENCE_NUMBER:
			return {
				...state,
				isLoading: false
			};
		case UPDATE_OUTGOING_CORRESPONDENCE_NUMBER:
			return {
				...state,
				outgoingCorrespondence: {
					...state.outgoingCorrespondence,
					rfiNumber: action.number
				}
			};
		case UPDATE_OUTGOING_CORRESPONDENCE_SAVE_PROGRESS:
			return {
				...state,
				saveResult: {
					...state.saveResult,
					progress: action.progress
				}
			};
		default:
			return state;
	}
};
